'use client';

/** Sondes de l'app (09/10) : écran vu à chaque changement de page, mesures Web Vitals. */
import { useEffect } from 'react';
import { usePathname } from 'next/navigation';
import { useReportWebVitals } from 'next/web-vitals';
import { sonde, envoyerSondes } from '@/lib/sonde';

const MESURES = new Set(['LCP', 'INP', 'CLS', 'FCP', 'TTFB']);

export function Sondes() {
  const chemin = usePathname();
  useEffect(() => { if (chemin) sonde('ecran', { chemin: chemin.slice(0, 80) }); }, [chemin]);
  useReportWebVitals((m) => {
    if (MESURES.has(m.name)) sonde('vitals', { nom: m.name, valeur: Math.round(m.name === 'CLS' ? m.value * 1000 : m.value), chemin: location.pathname.slice(0, 80) });
  });
  useEffect(() => {
    const cache = () => { if (document.visibilityState === 'hidden') envoyerSondes(); };
    document.addEventListener('visibilitychange', cache);
    return () => document.removeEventListener('visibilitychange', cache);
  }, []);
  return null;
}
